import DrugBase from './drugBase'
class Dilution extends DrugBase {
  constructor (id, name, substance, dosageForm, remark, dilutionInfos,
              modifiedDate, modifiedByHsaId, modifiedByName, isPublished) {
    super(modifiedDate, modifiedByHsaId, modifiedByName, isPublished)
    this.id = id
    this.name = name
    this.substance = substance
    this.dosageForm = dosageForm
    this.remark = remark
    this.dilutionInfos = dilutionInfos
  }
}

export default Dilution
